import snakecase from 'lodash.snakecase';

const injectCustomizations = (document, customization) => {
  const variables = Object.keys(customization);

  variables.forEach((variable) => {
    const snakeVariable = snakecase(variable);
    const value = customization[variable];
    const cssVariableName = `--${snakeVariable.replace(/_/g, '-')}`;
    document.style.setProperty(cssVariableName, value);
  });
};

export default injectCustomizations;
